

import { defineComponent, ref, computed, onMounted, reactive, watch } from "vue";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.js";
import axios from "@/axios-instance"
import { emitter } from "@/main";
import { sortByAlphabet } from "@/core/helpers/sortHelpers";


interface Form {
  status: string;
  fullName: string;
  gender: string;
  dateOfBirth: string;
  birthplace: string;
  phone: string;
  idCard: string;
  email: string;
  contactAddress: string;
  contactProvinceId: string;
  contactDistrictId: string;
  contactWardId: string;
  prProvinceId: string;
  prDistrictId: string;
  prWardId: string;
  prAddress: string;
}
export default defineComponent({
  name: "PersonallInfor",
  emits: ["changeEdit", "validateFail", "requestSave", "beforeSave"],
  props: {
    dataCustomer: { type: Object, required: true },
    isAddProfile: { type: Boolean},
    isEdit: { type: Boolean },
    // Ẩn nút Lưu/Hủy của riêng phần này (dùng khi gộp 1 form ở trang Thêm ứng viên — footer dùng nút của LearningInfor)
    hideActions: { type: Boolean, default: false },
    // Tiêu đề section hiển thị bên trong card (chỉ hiện khi truyền vào — vd trang Thêm ứng viên gộp 1 form)
    sectionTitle: { type: String, default: '' },
    // idDoc: { type: Object, required: true},
  },
  components: {
  },
  data() {
      return {
        dataResidenceDistrict: [] as any,
        dataDistrict: [] as any,

        dataResidenceProvince: [] as any,
        isLookingUp: false,

        
      }
  },
  
  methods: {
    
    submitForm(form) {
      //console.log('form',form)
      this.formLearningInfor = form.isValid
      // Gộp dữ liệu tab Học tập vào payload tạo mới (2 component giữ formData riêng → phải merge, nếu không sẽ thiếu field)
      if (form && form.learnData) {
        // 'transcript' PHẢI có trong list — thiếu là bảng điểm học bạ nhập ở drawer không được lưu khi tạo mới (bug 2026-07)
        const LEARN_KEYS = ['class10ProvinceId','class10DistrictId','class10SchoolId','class11ProvinceId','class11DistrictId','class11SchoolId','class12ProvinceId','class12DistrictId','class12SchoolId','graduatedYear','priorityObject','priorityArea','priorityScore','transcript']
        LEARN_KEYS.forEach(k => { (this.formData as any)[k] = form.learnData[k] })
      }
      this.submit()
    },
    async findTaxCode() {
      if (!this.formData.objectTax || !this.formData.objectTax.id) {
        Swal.fire({
          text: "Vui lòng nhập mã số thuế",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "Đóng",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
        return;
      }
      this.isLookingUp = true;
      try {
        const apiUrl = process.env.VUE_APP_VIETQR_API || 'https://api.vietqr.io/v2/business';
        const response = await axios.get(`${apiUrl}/${this.formData.objectTax.id}`);
        if (response.data.code === '00' && response.data.data) {
          this.formData.objectTax.name = response.data.data.name;
          this.formData.objectTax.internationalName = response.data.data.internationalName;
          this.formData.objectTax.shortName = response.data.data.shortName;
          this.formData.objectTax.address = response.data.data.address;
          // Sync with the existing taxNumber field if it exists
          this.formData.taxNumber = response.data.data.id;
        } else {
          Swal.fire({
            text: response.data.desc || "Không tìm thấy thông tin mã số thuế",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Đóng",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
        }
      } catch (error) {
        console.error('Error finding tax code:', error);
        Swal.fire({
          text: "Có lỗi khi truy cứu mã số thuế",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Đóng",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      } finally {
        this.isLookingUp = false;
      }
    },
    loadDefaultData() {
      // HỦY = REVERT thật (convention drawer-cancel-revert): trước đây chỉ thoát edit — dữ liệu gõ dở vẫn dính ở chế độ xem
      ;(this as any).initFromCustomer(this.dataCustomer)
      this.$emit("changeEdit", {isCanceled:true});
    },
    openScanCccd() {
      // Mở modal Phân tích AI (quét CCCD) ở candidateListDetail qua global emitter
      emitter.emit("openCccdScan")
    },
    async autofillAddress(value) {
      if(value) {
        this.formData.contactProvinceId = this.formData.prProvinceId
        // this.dataDistrict = await this.getDistrict(this.formData.contactProvinceId)
        // this.formData.contactDistrictId = this.formData.prDistrictId
        this.dataWard = await this.getWard(this.formData.contactProvinceId)
        this.formData.contactWardId = this.formData.prWardId
        this.formData.contactAddress = this.formData.prAddress
      }
    },
    async provinceChange(id:string) {
      // this.dataDistrict = []
      // if(this.formData.contactDistrictId != "") {
      //   this.formData.contactDistrictId = ""
      // }
      // this.dataWard = []
      // if(this.formData.contactWardId != "") {
      //   this.formData.contactWardId = ""
      // }
      // this.dataDistrict = await this.getDistrict(id)
      this.districtChange(id)
    },
    async districtChange(id:string) {
      this.dataWard = await this.getWard(id)
    },
    
    async residenceProvinceChange(id:string) {
      this.dataResidenceDistrict = []
      if(this.formData.prDistrictId != "") {
        this.formData.prDistrictId = ""
      }
      this.dataResidenceWard = []
      if(this.formData.prWardId != "") {
        this.formData.prWardId = ""
      }
      // this.dataResidenceDistrict = await this.getDistrict(id)
      this.residenceDistrictChange(id)
    },
    async residenceDistrictChange(id:string) {
      this.dataResidenceWard = await this.getWard(id)
    },
    async getDistrict(id:string) {
      let arrTemp = []
      await axios.get(`/res/district/?provinceId=${id}`)
      .then(( {data} ) => {
        arrTemp = data
      })
      .catch(({ response }) => {
      });
      return arrTemp
    },
    async getWard(id:string) {
      let arrTemp = JSON.parse(JSON.stringify(this.dataProvince)).find(i => i.id == id)
      if(arrTemp) {
        let temp = arrTemp.wards?.map(i=>({
          ...i,
          id: i.code,
          label: i.name,
          value: i.code,
        }))||[]
        temp = sortByAlphabet(temp,'name')
        // console.log('arrTemp.wards',temp)
        return temp
      }

      // await axios.get(`/res/ward/?districtId=${id}`)
      // .then(( {data} ) => {
      //    arrTemp = data
      // })
      // .catch(({ response }) => {
      //   console.log('err',response)
      // });
      // return arrTemp
    },
    async loadInitialWards() {
      if (this.formData.contactProvinceId) {
        this.dataWard = await this.getWard(this.formData.contactProvinceId.toString());
      }
      if (this.formData.prProvinceId) {
        this.dataResidenceWard = await this.getWard(this.formData.prProvinceId.toString());
      }
    },
  },
  async mounted() {
    await axios.get('/res/newprovince/list')
    .then(( {data} ) => {
      this.dataProvince = data.map((item) => {
        return {
          ...item,
          id: item.code,
          wards: item.wards.map((ward) => {
            return {
              ...ward,
              provinceCode: ward.code
            }
          }),
        }
      })
      
      if(!this.isAddProfile) {
        this.loadInitialWards();
      }
    })
    .catch(({ response }) => {
    });
    //Danh mục Dân tộc/Tôn giáo (cùng nguồn /ethnic, /religion với cổng nhập học -> giá trị khớp khi so lệch)
    axios.get('/ethnic')
      .then(({ data }) => { this.arrEthnic = (data || []).map((i) => ({ value: i.name, label: i.name })) })
      .catch(() => {});
    axios.get('/religion')
      .then(({ data }) => { this.arrReligion = (data || []).map((i) => ({ value: i.name, label: i.name })) })
      .catch(() => {});
  },
  setup(props, {emit}) {
    const formRef = ref<null | HTMLFormElement>(null);
    const formLearningInfor = ref(false)
    const messErr = ref('')
    const addCustomerModalRef = ref<null | HTMLElement>(null);
    const dataResidenceWard = ref([] as any)
    const dataProvince = ref([] as any)
    const dataWard = ref([] as any)
    //Danh mục Dân tộc/Tôn giáo lấy từ BE (/ethnic, /religion) — cùng nguồn với cổng nhập học để giá trị khớp khi so lệch
    const arrEthnic = ref([] as any)
    const arrReligion = ref([] as any)
    const arrNational = ref([
      { value: "Việt Nam", label: "Việt Nam" },
      { value: "Khác", label: "Khác" },
    ] as any)

    const rules = ref({
      fullName: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "blur",
        },
      ],
      //type boolean: Nữ = false — thiếu type thì async-validator coi là string, chọn Nữ vẫn báo lỗi
      gender: [
        {
          required: true,
          type: "boolean",
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      dateOfBirth: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "blur",
        },
      ],
      //key PHẢI trùng prop của el-form-item (trước ghi "birthplace" thường -> rule không chạy)
      birthPlace: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      //Ngày cấp: el-date-picker phát "change" (blur không đáng tin) — cùng kiểu với các select
      dateOfIssue: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      issuePlace: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      phone: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "blur",
        },
      ],
      idCard: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "blur",
        },
      ],
      email: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "blur",
        },
      ],
      contactAddress: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "blur",
        },
      ],
      contactProvinceId: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "blur",
        },
      ],
      contactWardId: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "blur",
        },
      ],
      prProvinceId: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "blur",
        },
      ],
      prWardId: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "blur",
        },
      ],
      prAddress: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "blur",
        },
      ],
      highschoolGraduation: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "blur",
        },
      ],
      //Dân tộc/Tôn giáo/Quốc tịch: select nên trigger "change" (giống birthPlace/issuePlace)
      ethnic: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      religion: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
      nationality: [
        {
          required: true,
          message: "Vui lòng điền trường này",
          trigger: "change",
        },
      ],
    })
    const localFormData = reactive({} as any)
    
    // Đồng bộ localFormData từ dataCustomer — TÁCH thành hàm để "Hủy bỏ" revert lại đúng logic này
    const initFromCustomer = (newVal: any) => {
      // Re-initialize localFormData while keeping reactivity
      Object.keys(localFormData).forEach(key => delete localFormData[key])
      Object.assign(localFormData, JSON.parse(JSON.stringify(newVal)))
      
      // Initialize objectTax if missing
      if (!localFormData.objectTax) {
        localFormData.objectTax = {
          id: '',
          name: '',
          internationalName: '',
          shortName: '',
          address: '',
          email: ''
        }
      } else {
        // Ensure all properties exist in objectTax for consistency
        const defaultFields = ['id', 'name', 'internationalName', 'shortName', 'address', 'email']
        defaultFields.forEach(field => {
          if (localFormData.objectTax[field] === undefined) {
            localFormData.objectTax[field] = ''
          }
        })
      }

      if (!localFormData.objectTax.id && localFormData.taxNumber) {
        localFormData.objectTax.id = localFormData.taxNumber
      }

      if (localFormData.newContactProvinceCode) {
        localFormData.contactProvinceId = +localFormData.newContactProvinceCode
      }
      if (localFormData.newContactWardCode) {
        localFormData.contactWardId = +localFormData.newContactWardCode
      }

      if (localFormData.newPrProvinceCode) {
        localFormData.prProvinceId = +localFormData.newPrProvinceCode
      }
      if (localFormData.newPrWardCode) {
        localFormData.prWardId = +localFormData.newPrWardCode
      }

      // Nạp options Phường/Xã theo Tỉnh đã chọn để el-select hiển thị TÊN thay vì mã khi mở chỉnh sửa
      // (mounted() chạy trước khi dataCustomer về nên loadInitialWards ban đầu rỗng — phải nạp lại tại đây)
      if (dataProvince.value && dataProvince.value.length) {
        const _wardsOf = (pid) => {
          const p = dataProvince.value.find(i => i.id == pid)
          return (p && p.wards) ? sortByAlphabet(p.wards.map(w => ({ ...w, id: w.code, label: w.name, value: w.code })), 'name') : []
        }
        if (localFormData.prProvinceId) dataResidenceWard.value = _wardsOf(localFormData.prProvinceId)
        if (localFormData.contactProvinceId) dataWard.value = _wardsOf(localFormData.contactProvinceId)
      }
    };
    watch(() => props.dataCustomer, initFromCustomer, { immediate: true, deep: true })

    const formData = computed(() => localFormData);

    // Cảnh báo field bắt buộc còn thiếu (giống tab Thông tin học tập) — KHÔNG chặn lưu
    const missingImportant = computed(() => {
      const f:any = localFormData
      const m:string[] = []
      if (!f.fullName) m.push('Họ tên')
      if (!f.dateOfBirth) m.push('Ngày sinh')
      if (!f.idCard) m.push('CMND/CCCD')
      if (!f.dateOfIssue) m.push('Ngày cấp')
      if (!f.issuePlace) m.push('Nơi cấp')
      if (!f.phone) m.push('Điện thoại')
      if (!f.email) m.push('Email')
      if (!f.ethnic) m.push('Dân tộc')
      if (!f.religion) m.push('Tôn giáo')
      if (!f.nationality) m.push('Quốc tịch')
      if (!f.prProvinceId) m.push('Tỉnh thường trú')
      if (!f.prWardId) m.push('Phường/Xã thường trú')
      if (!f.prAddress) m.push('Địa chỉ thường trú')
      if (!f.contactProvinceId) m.push('Tỉnh liên lạc')
      if (!f.contactWardId) m.push('Phường/Xã liên lạc')
      if (!f.contactAddress) m.push('Địa chỉ liên lạc')
      return m
    });
  
    const userLocal = computed(() => {
      let temp = window.localStorage.getItem("user")
      return temp ? JSON.parse(temp) : null
    });
    const idCardOld = ref('')
    onMounted(()=> {
      setTimeout(() => {
        idCardOld.value = props.dataCustomer.idCard
        checkIdCard()
      },100)
    })
    
    // Suy các field dẫn xuất (mã/tên Tỉnh-Phường/Xã mới) NGAY VÀO formData, để trang cha có thể trộn
    // sửa đổi của tab này sang tab kia trước khi lưu (xem saveEditTab ở candidateListDetail).
    const applyDerived = () => {
      const f: any = localFormData
      if (f.contactProvinceId) {
        f.newContactProvinceCode = f.contactProvinceId.toString()
        f.newContactProvinceName = dataProvince.value.find((i: any) => i.code == f.contactProvinceId)?.name
      }
      if (f.contactWardId) {
        f.newContactWardCode = f.contactWardId.toString()
        f.newContactWardName = dataWard.value.find((i: any) => i.code == f.contactWardId)?.name
      }
      if (f.prProvinceId) {
        f.newPrProvinceCode = f.prProvinceId.toString()
        f.newPrProvinceName = dataProvince.value.find((i: any) => i.code == f.prProvinceId)?.name
      }
      if (f.prWardId) {
        f.newPrWardCode = f.prWardId.toString()
        f.newPrWardName = dataResidenceWard.value.find((i: any) => i.code == f.prWardId)?.name
      }
    }
    const saving = ref(false) // chống double-click: Thêm mới POST /admission/student/v2 -> bấm 2 lần = tạo TRÙNG ứng viên
    const submit = async () => {
      if (!formRef.value) {
        return;
      }
      if (saving.value) return; // đang lưu -> chặn cú bấm thứ 2
      saving.value = true;
      try {
      // Nút Lưu NẰM TRONG form này gọi thẳng submit(), KHÔNG đi qua saveEditTab của trang cha
      // -> xin trang cha trộn sửa đổi của tab kia vào formData trước (emit đồng bộ).
      if (!props.isAddProfile) emit('beforeSave', 'personal')
      // Thêm mới: CHO LƯU THIẾU (banner "Còn thiếu" đã cảnh báo) — validate chỉ tô đỏ field.
      // Chặn tối thiểu còn giữ: phải có Họ tên (record vô danh vô nghĩa) + không trùng CCCD (checkIdCard bên dưới).
      if (props.isAddProfile) {
        await formRef.value.validate().catch(() => { /* không chặn */ })
        if (!formData.value.fullName || !String(formData.value.fullName).trim()) {
          Swal.fire({
            text: "Vui lòng nhập Họ tên ứng viên trước khi lưu.",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "Đóng",
            customClass: { confirmButton: "btn btn-primary" },
          })
          emit("validateFail")
          return
        }
      }
      // Thân lưu chạy vô điều kiện (sửa = không chặn)
      {
        {
          if(props.isAddProfile && !formLearningInfor.value) {
            return
          }
          await checkIdCard()
          if(messErr.value != '') {
            // TRƯỚC ĐÂY: return âm thầm -> bấm Lưu như không có chuyện gì, KHÔNG field nào được lưu.
            // Tệ hơn: checkIdCard báo trùng CẢ KHI người dùng KHÔNG đụng vào CCCD (chỉ cần DB đang có
            // bản trùng sẵn) => hồ sơ đó vĩnh viễn không lưu được tab Cá nhân mà không hiện lỗi gì.
            // NAY: chỉ CHẶN khi CCCD vừa bị ĐỔI sang giá trị trùng, và phải báo rõ lý do.
            const _idNow = String(formData.value.idCard || '').trim()
            const _idOld = String(idCardOld.value || '').trim()
            if (_idNow !== _idOld) {
              Swal.fire({
                title: "Không lưu được",
                html: `CMND/CCCD <b>${_idNow}</b> đã thuộc hồ sơ khác:<br/>${messErr.value}<br/>`
                  + `<span class="fs-8 text-muted">Vui lòng nhập đúng CCCD hoặc xử lý hồ sơ trùng trước khi lưu.</span>`,
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: "Đóng",
                customClass: { confirmButton: "btn btn-primary" },
              })
              return
            }
            // CCCD KHÔNG đổi (trùng có sẵn từ trước) -> chỉ cảnh báo dưới ô CCCD, VẪN CHO LƯU các field khác.
          }

          let urlApi = `/admission/student/${formData.value.id}`
          let method = 'put'
          
          let tempData = JSON.parse(JSON.stringify(formData.value))
          const cleanEmpty = (obj) => {
            Object.keys(obj).forEach(key => {
              if (obj[key] === "") {
                delete obj[key];
              } else if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
                cleanEmpty(obj[key]);
              }
            });
          };
          cleanEmpty(tempData);
          tempData.gender = tempData.gender?"1":"0"
          tempData.fullName = (tempData.fullName || '').trim().toUpperCase()
          tempData.idCard = (tempData.idCard || '').trim()

          
          if(tempData.updatedAt) {
            delete tempData.updatedAt
          }
          if(tempData.createdAt) {
            delete tempData.createdAt
          }
          if(!tempData.birthPlace) {
            delete tempData.birthPlace
          }
          //Ngày cấp trống thì KHÔNG gửi (giống birthPlace/ethnic): phòng payload thiếu field làm ghi đè null lên
          //giá trị đang có — cột này SIS đọc và khối so lệch 3 bảng có đối chiếu.
          if(!tempData.dateOfIssue) {
            delete tempData.dateOfIssue
          }
          if(!tempData.class10DistrictId) {
            delete tempData.class10DistrictId
          }
          if(!tempData.class10ProvinceId) {
            delete tempData.class10ProvinceId
          }
          if(!tempData.class10SchoolId) {
            delete tempData.class10SchoolId
          }
          if(!tempData.class11DistrictId) {
            delete tempData.class11DistrictId
          }
          if(!tempData.class11ProvinceId) {
            delete tempData.class11ProvinceId
          }
          if(!tempData.class11SchoolId) {
            delete tempData.class11SchoolId
          }
          if(!tempData.class12DistrictId) {
            delete tempData.class12DistrictId
          }
          if(!tempData.class12ProvinceId) {
            delete tempData.class12ProvinceId
          }
          if(!tempData.class12SchoolId) {
            delete tempData.class12SchoolId
          }
          if(!tempData.class12RankedAcademic) {
            delete tempData.class12RankedAcademic
          }
          if(!tempData.class12RankedConduct) {
            delete tempData.class12RankedConduct
          }
          if(!tempData.contactAddress) {
            delete tempData.contactAddress
          }
          if(!tempData.contactDistrictId) {
            delete tempData.contactDistrictId
          }
          if(tempData.contactProvinceId) {
            tempData.newContactProvinceCode = tempData.contactProvinceId.toString()
            tempData.newContactProvinceName = dataProvince.value.find(i => i.code == tempData.contactProvinceId)?.name
          }
          if(tempData.contactWardId) {
            tempData.newContactWardCode = tempData.contactWardId.toString()
            tempData.newContactWardName = dataWard.value.find(i => i.code == tempData.contactWardId)?.name
          }
          if(tempData.prProvinceId) {
            tempData.newPrProvinceCode = tempData.prProvinceId.toString()
            tempData.newPrProvinceName = dataProvince.value.find(i => i.code == tempData.prProvinceId)?.name
          }
          if(tempData.prWardId) {
            tempData.newPrWardCode = tempData.prWardId.toString()
            tempData.newPrWardName = dataResidenceWard.value.find(i => i.code == tempData.prWardId)?.name
          }
          // Field THUỘC tab Thông tin học tập: chỉ gửi khi THỰC SỰ đổi (được trộn sang từ tab kia).
          // Nếu không, clone cũ của tab Cá nhân sẽ ĐÈ MẤT điểm/trường vừa nhập bên tab Học tập.
          const LEARNING_ONLY = [
            'transcript', 'graduationscore', 'graduatedYear', 'priorityObject', 'priorityArea', 'priorityScore',
            'class10ProvinceId', 'class10DistrictId', 'class10SchoolId', 'class10SchoolName',
            'class11ProvinceId', 'class11DistrictId', 'class11SchoolId', 'class11SchoolName',
            'class12ProvinceId', 'class12DistrictId', 'class12SchoolId', 'class12SchoolName',
          ]
          LEARNING_ONLY.forEach((k) => {
            if (JSON.stringify(tempData[k]) === JSON.stringify((props.dataCustomer as any)?.[k])) delete tempData[k]
          })
          if(!tempData.priorityArea) {
            delete tempData.priorityArea
          }
          if(!tempData.priorityObject) {
            delete tempData.priorityObject
          }
          // if(!tempData.priorityScore) {
          //   delete tempData.priorityScore
          // }
          if(!tempData.religion) {
            delete tempData.religion
          }
          if(!tempData.ethnic) {
            delete tempData.ethnic
          }
          if(!tempData.nationality) {
            delete tempData.nationality
          }
          // console.log('tempData',tempData)
          if (!props.isAddProfile) {
            // delete tempData.verifiedDate
            delete tempData.highschoolGraduation
            delete tempData.status
          }
          if(props.isAddProfile) {
            urlApi = '/admission/student/v2/'
            method = 'post'
            tempData.assignee = userLocal.value.id

            // formData.value.verifiedDate = formData.value.highschoolGraduation != 'not_graduated'?formData.value.verifiedDate:undefined
          }
          await axios[method](`${urlApi}`, tempData)
          .then(( {data} ) => {
            if(tempData.id) {
              axios.post(`/admission/register/generate/${tempData.id}`)
            }
            idCardOld.value = data.idCard
            emit("changeEdit", {isConfirmed : true, data: data});
            // Chế độ Thêm: để trang Thêm tự hỏi "làm gì tiếp theo" — KHÔNG bật Swal "Lưu thành công" đè lên popup đó
            if (!props.isAddProfile) {
              Swal.fire({
                  text: "Lưu thành công",
                  icon: "success",
                  timer: 2000,
                  timerProgressBar: true,
                  buttonsStyling: false,
                  confirmButtonText: "Đóng",
                  customClass: {
                      confirmButton: "btn btn-primary",
                  },
              }).then(() => {
                  hideModal(addCustomerModalRef.value);
              });
            }
          })
          .catch(({ response }) => {
              Swal.fire({
                  text: response.data?.errorMessage || "Có lỗi trong quá trình thực hiện.",
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Làm mới lại trang",
                  customClass: {
                      confirmButton: "btn btn-primary",
                  },
              }).then(() => {
                  location.reload()
              });
            });
        }
      }
      } finally {
        saving.value = false; // mở khoá nút Lưu mọi nhánh (thành công/lỗi/return sớm)
      }
    };
    async function checkIdCard() {
      let cardId = {
        idCard: formData.value.idCard
      }
      await axios.post('/admission/student/idcardcount',cardId)
      .then(( {data} ) => {
        if(!props.isAddProfile) {  
          if(data.idCard === idCardOld.value && data.count === 1) {
            messErr.value = ''
          }
          else if(data.idCard !== idCardOld.value && data.count === 0){
            messErr.value = ''
          }
          else {
            let a = ''
            let arrStudent = data.student.filter(item => item.id != formData.value.id)
            arrStudent.forEach((item,index) => {
              a += `<a target='_blank' class="text-danger" href='/danhsachungvien/${item.id}'>${item.fullName}</a>${index != arrStudent.length-1?',':''}`
            })
            if(a!='') {
              messErr.value = `Thí sinh trùng CMND/CCCD: ${a}`
            }
            let scrollDiv = document.getElementById("tick-scroll")?.offsetTop || 0;
            window.scrollTo({ top: scrollDiv, behavior: 'smooth'});

          }
        }
        else {
          if(data.count != 0) {
            let a = ''
            data.student.forEach((item,index) => {
              a += `<a target='_blank' class="text-danger" href='/danhsachungvien/${item.id}'>${item.fullName}</a>${index != data.student.length-1?',':''}`
            })
            messErr.value = `Thí sinh trùng CMND/CCCD: ${a}`
            let scrollDiv = document.getElementById("tick-scroll")?.offsetTop || 0;
            window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
          }
          else {
            messErr.value = ''
          }
        }
         //arrTemp = data
      })
      .catch(({ response }) => {
      });
    }
    return {
      formData,
      missingImportant,
      messErr,
      formRef,
      rules,
      submit,
      saving,
      applyDerived,
      initFromCustomer,
      formLearningInfor,
      idCardOld,
      checkIdCard,
      dataResidenceWard,
      dataProvince,
      dataWard,
      arrEthnic,
      arrReligion,
      arrNational,
    };
  },
});
